<template>
  <div class="mt-4 bg-white p-4" v-if="showChangeLog">
    <h3 class="form__section-heading">Changelog</h3>

    <vue-good-table
      mode="remote"
      theme="polar-bear"
      :rows="changelogData.rows"
      :columns="changelogData.columns"
      :total-rows="changelogData.totalRows"
      :is-loading.sync="changelogData.isLoading"
      :pagination-options="{
        enabled: true,
        dropdownAllowAll: false,
        perPageDropdown: perPageDropdown,
        rowsPerPageLabel: 'Results per page',
      }"
      :sort-options="{
        multipleColumns: false,
      }"
      styleClass="vgt-table striped bordered"
      @on-page-change="onPageChange"
      @on-per-page-change="onPerPageChange"
      @on-sort-change="onSortChange"
    >
      <template slot="table-row" slot-scope="props">
        <template v-if="props.column.field == 'values'">
          <span class="block" v-for="row in props.row.values" :key="row.id">
            {{ row }}
          </span>
        </template>
      </template>
    </vue-good-table>
  </div>
</template>

<script>
import { VueGoodTable } from "vue-good-table";
import "vue-good-table/dist/vue-good-table.css";

export default {
  components: {
    VueGoodTable,
  },
  computed: {
    getId() {
      return this.$route.params.id;
    },
    getEndpoint() {
      return this.$route.meta.endpoint;
    },
  },
  created() {
    // this.loadChangelogData();
  },
  data() {
    return {
      showChangeLog: false,
      changelogData: {
        isLoading: true,
        rows: [],
        totalRows: 0,
        limit: 10,
        currentPage: 1,
        search: "",
        filterParams: "",
        columns: [
          {
            label: "Date / Time",
            field: "created_at",
          },
          {
            label: "User",
            field: "created_by",
            sortable: false,
          },
          {
            label: "Action",
            field: "type",
            sortable: false,
          },
          {
            label: "Data",
            field: "values",
            sortable: false,
          },
        ],
        order_field: "created_at",
        order_dir: "desc",
      },
    };
  },
  methods: {
    onPageChange(e) {
      this.changelogData.currentPage = e.currentPage;
      this.loadChangelogData();
    },
    onPerPageChange(e) {
      this.changelogData.limit = e.currentPerPage;
      this.loadChangelogData();
    },
    onSortChange(e) {
      this.changelogData.order_field = e[0].field;
      this.changelogData.order_dir = e[0].type == "none" ? "asc" : e[0].type;
      this.changelogData.currentPage = 1;
      this.loadChangelogData();
    },
    loadChangelogData() {
      this.debounce(() => {
        this.changelogData.isLoading = true;
        this.$http
          .get(
            process.env.VUE_APP_API_URL +
              `/${this.getEndpoint}/${this.getId}/changelog?page=${this.changelogData.currentPage}&limit=${this.changelogData.limit}&sort_by=${this.changelogData.order_field}&sort_dir=${this.changelogData.order_dir}`
          )
          .then((res) => {
            this.changelogData.rows = res.data.data;
            this.changelogData.totalRows = res.data.total;
          });
      }, 500);
    },
  },
};
</script>